"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SuccessMsg = void 0;
var _reactRedux = require("react-redux");
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Alert = _interopRequireWildcard(require("../../../../../../../ui/Alert"));
var _selectors = require("../../store/selectors");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var SuccessMsg = exports.SuccessMsg = function SuccessMsg(_ref) {
  var className = _ref.className;
  var bookingConfirmation = (0, _reactRedux.useSelector)(_selectors.getBookingConfirmation);
  var _useTranslation = (0, _reactI18next.useTranslation)('BOOKING_FORM_BY_OPERATOR'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_Alert.default, {
    className: className,
    type: _Alert.TYPES.SUCCESS
  }, /*#__PURE__*/_react.default.createElement("b", null, t('SUCCESS_BOOKING_MESSAGE_HEADER'), /*#__PURE__*/_react.default.createElement("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    href: bookingConfirmation.viewLink
  }, bookingConfirmation.id)), /*#__PURE__*/_react.default.createElement("div", null, t('SUCCESS_BOOKING_MESSAGE_DESC'), /*#__PURE__*/_react.default.createElement("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    href: bookingConfirmation.bookingsLink
  }, t('SUCCESS_BOOKING_MESSAGE_DESC_LINK'))));
};